import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import downArrowIcon from '../../../../../assets/icons/left-ar.svg';
import appLS from '../../../../../constants/local-storage';
import getProducts from '../../../../../redux/actions/products/getProducts';
import setIsCompanySelected from '../../../../../redux/actions/companies/setIsCompanySelected';
import getUser from '../../../../../redux/actions/user/getUser';
import apiService from '../../../../../services/apiService';

export default function CompanyDropdown(params) {

  const companies = useSelector(state => state.companies);
  const products = useSelector(state => state.products);
  const user = JSON.parse(localStorage.getItem(appLS.user));
  
  const [companyName, setCompanyName] = useState(null)
  const dispatch = useDispatch();
  const { t: trans } = useTranslation();

  useEffect(() => {
    setCompanyName(getCompanyName())    
  }, []);

  useEffect(() => {
    if (companies && Object.entries(companies.data).length > 0) {
      const company = companies.data.filter(comp => comp.Key === localStorage.getItem(appLS.companyKey))
      setCompanyName(company.length > 0 ? company[0].Name : trans('common-action.select-company'));
    }
  }, [products, companies])
  
  const getCompanyName = () => {
    if (companies && Object.entries(companies.data).length > 0) {
      const company = companies.data.filter(comp => comp.Key === localStorage.getItem(appLS.companyKey))
      return company.length > 0 ? company[0].Name : trans('common-action.select-company')
    }
  }

  const onCompanySelect = (key) => {
    localStorage.setItem(appLS.companyKey, key);
    apiService.setCompanyKey();
    dispatch(getUser());
    dispatch(getProducts());
    setCompanyName(getCompanyName());
    dispatch(setIsCompanySelected(true));
  }

  return <>{
    user && companyName ? (
      <div className='company-dropdown'>
        <label>
          <span>{trans('common-action.company')} ({companyName})</span>
          <img src={downArrowIcon} alt="DropDownArrow" />
          <section>
            {
              companies && companies.pending ?
              <p>{trans('common-action.please-wait')}</p> :
              <ul>
                {!companies.error && Object.entries(companies.data).length > 0 && companies.data.map(comp => (
                  <li key={comp.Key} onClick={() => { onCompanySelect(comp.Key) }}>{comp.Name}</li>)
                )}
              </ul>
            }
          </section>
        </label>
      </div> 
    ) : null
  }</>
}